import Class from './c-content-chart-bars';
import './c-content-chart-bars@.vue';

export default Class;